import React from 'react';
import ValidationList from './ValidationList';
import { ValidationSummaryContentStyled, ValidationSummaryStyled } from './ValidationSummary.styles';
import { IValidationResult } from '../../../services/Validation/interfaces';

interface IValidationSummary {
  summary: string;
  items: IValidationResult[];
}

export default class ValidationSummary extends React.Component<IValidationSummary> {
  public render() {
    return (
      <ValidationSummaryStyled>
        <ValidationSummaryContentStyled>{this.props.summary}</ValidationSummaryContentStyled>
        <ValidationList items={this.props.items.filter((item) => !item.valid)} />
      </ValidationSummaryStyled>
    );
  }
}
